/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface InsuranceCardReaderOutput {
  member_id?: string | null;
  group_number?: string | null;
  carrier_name?: string | null;
  plan_name?: string | null;
  rx_bin?: string | null;
  rx_pcn?: string | null;
  rx_group?: string | null;
}
